import { Loader, Skeleton, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { IconEyeClosed } from "@tabler/icons-react";
import { TagIcon } from "@/lib/tag-utils";
import { ServiceCategory } from "@turizi/shared";

interface Props {
    categories: ServiceCategory[];
    selectedCategory: string | null;
    isLoadingCategories: boolean;
    onSelectCategory: (category: string) => void;
    showServiceGroups?: boolean;
    isLoadingServiceGroups?: boolean;
}

export default function ServicesCategorySelector({
    categories,
    selectedCategory,
    isLoadingCategories,
    onSelectCategory,
    showServiceGroups,
    isLoadingServiceGroups,
}: Props) {
    const { t } = useTranslation();

    if (isLoadingCategories || isLoadingServiceGroups) {
        return (
            <div className={`flex gap-4 items-center overflow-x-auto no-scrollbar pb-2`}>
                {Array(5).fill(0).map((_, i) => (
                    <Skeleton key={i} width={100} height={36} radius="xl" />
                ))}
            </div>
        );
    }

    return (
        <div className={`flex gap-2 items-center overflow-x-auto no-scrollbar pb-2`}>
            {showServiceGroups && !isLoadingServiceGroups && (
                <div
                    key="service_groups"
                    onClick={() => onSelectCategory('service_groups')}
                    className={`
                        cursor-pointer
                        px-4 py-1 rounded-full
                        text-center whitespace-nowrap flex items-center
                        ${selectedCategory === 'service_groups'
                            ? 'bg-indigo-200 text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}
                    `}
                >
                    <TagIcon
                        name="service_groups"
                        size="sm"
                    />
                </div>
            )}

            {categories.map(category => {
                const isInternal = category.rank === 0 || category.rank === null;
                const isSelected = selectedCategory === category.category;

                return (
                    <div
                        key={category.category}
                        onClick={() => onSelectCategory(category.category)}
                        className={`
                        cursor-pointer
                        text-center whitespace-nowrap flex items-center gap-2
                    `}
                    >
                        <TagIcon
                            plural
                            name={category.category}
                            size="md"
                            isSelected={isSelected}
                            rightSection={isInternal ? (
                                <Tooltip label={t('internal_use')} withArrow>
                                    <IconEyeClosed size={16} stroke={2} color="black" />
                                </Tooltip>
                            ) : null}
                        />
                    </div>
                )
            })}

        </div>
    );
}
